import { useQuery } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import { billingOverviewQuery } from '../../shared/api/billing-queries.js';
import { daysLeft } from '../settings/billing-card.js';

/**
 * Said once, at the top, only to the person who pays: the trial is ending,
 * or it has ended and new documents are waiting. Silent otherwise.
 */
export function BillingBanner() {
  const overview = useQuery(billingOverviewQuery());
  const account = overview.data?.account;
  if (account == null || account.hasPaymentMethod) return null;

  const left = account.status === 'trialing' ? daysLeft(account.trialEndsAt) : null;
  const lapsed = !account.inGoodStanding;
  if (!lapsed && (left === null || left > 7)) return null;

  return (
    <div
      className={`mb-6 flex flex-wrap items-center justify-between gap-2 rounded-[var(--radius-control)] border px-4 py-3 text-sm ${
        lapsed
          ? 'border-danger/30 bg-danger/10 text-danger'
          : 'border-warning/30 bg-warning/10 text-content'
      }`}
    >
      <span>
        {lapsed
          ? 'The trial has ended. New documents are kept but not read until billing is set up.'
          : `The trial ends in ${String(left)} day${left === 1 ? '' : 's'}.`}
      </span>
      <Link to="/settings" className="font-medium underline">
        Set up billing
      </Link>
    </div>
  );
}
